import { JSX, ReactNode } from 'react'

import { HStack, VStack, Separator, Text } from '@chakra-ui/react'
import type { StackProps, AvatarRootProps, TextProps } from '@chakra-ui/react'

// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Avatar from '@/components/ui/avatar.tsx'




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Span (props: TextProps): JSX.Element
{
	return (
		<Text
			as="span"
			color="fg.subtle"
			fontSize="sm"
			whiteSpace="nowrap"

			{...props}

		/>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function B (props: TextProps): JSX.Element
{
	return (
		<Text
			as="b"
			color="fg"
			fontSize="xl"
			fontWeight="normal"
			whiteSpace="nowrap"

			{...props}

		/>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Feild
(
	props: StackProps
		& {
			label   : string
			children: ReactNode

		},

)
:	JSX.Element
{
	return (
		<VStack gap="0" flexShrink="0" {...props}>
			<Span>{props.label}</Span>

			<HStack gap="1">{props.children}</HStack>

		</VStack>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Posy
(
	props: {
		name   : string
		text   : string
		avatar?: string
		size?  : AvatarRootProps['size']
		w?     : StackProps['w']

	},

)
:	JSX.Element
{
	return (
		<HStack gap="4">
			<Avatar.Single size={props.size} src={props.avatar} />

			<VStack gap="0" flexShrink="0" align="start" {...props}>
				<B fontWeight="bold">{props.name}</B>

				<Span>{props.text}</Span>

			</VStack>

		</HStack>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Divider (): JSX.Element
{
	return (
		<Separator
			h="8"
			orientation="vertical"
			flexShrink="0"
			// eslint-disable-next-line @typescript-eslint/naming-convention
			ml={{ 'base': 2, 'xl': 18, '2xl': 24 }}
			// eslint-disable-next-line @typescript-eslint/naming-convention
			mr={{ 'base': 2, 'xl': 4, '2xl': 6 }}

		/>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Root
(props: StackProps): JSX.Element
{
	return (
		<HStack
			w="full"
			p="2"
			rounded="md"
			minW="fit-content"
			justify="space-between"
			_hover={{ bg: 'bg.subtle' }}

			{...props}

		/>

	)

}
